var app = angular.module("leonardo");

var DocumentListReport = function($scope, $window, $filter, FolderFileService, ngDialog, FilterService, AuthDataService,
                                  NotificationService, $timeout, $controller, $q, AttachmentService, AnalyticsService) {

  $scope.order = '-created';

  $scope.folderFileService = FolderFileService;
  $scope.attachmentService = AttachmentService;

  $scope.getEntitiesPromise = function(options) {
    var defer = $q.defer();
    options['type'] = FolderFileService.TYPE_REPORT;
    options['account'] = FilterService.getFilter('account_reports');
    options['group'] = FilterService.getFilter('group_reports');
    options['portfolio'] = FilterService.getFilter('portfolio_reports');
    options['property'] = FilterService.getFilter('property_reports');
    $scope.loading = true;
    FolderFileService.getlist(options).then(function(data) {
      $scope.loading = false;
      var results = data.results ? data.results : data;
      if (results.length === 0) {
        ngDialog.open({ template: 'views/templates/dialog/no-results.html'});
      }
      defer.resolve(data);
    }).finally(function() {
      $scope.loading = false;
    });
    return defer.promise;
  };

  $scope.showFile = function(file){
    AnalyticsService.track('Document Opened', {
      ...AnalyticsService.getDocumentGroupProperties(file),
      context: 'Report Warehouse'
    });
    if (file.document_file) {
      // Use signed_view_url for secure inline viewing, fallback to secure_share_url
      $window.open(file.document_file.signed_view_url || file.document_file.secure_share_url, '_blank');
    }
    else if (file.link) {
      $window.open(file.link, '_blank');
    }
    else {
      // Use signed_view_url for secure inline viewing, fallback to secure_share_url
      $window.open(file.signed_view_url || file.secure_share_url, '_blank');
    }
  };

  $scope.getSector = function() {
    if ((AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin())) {
      return FilterService.hasFilter('sector') ? FilterService.getFilter('sector') : null;
    }
    return null;
  };

  $scope.onEditFile = function(file) {
    ngDialog.open({
      template: 'views/templates/dialog/folder-file/upload.html',
      controller: 'FolderFileAdd',
      resolve: {
        folder: ['FolderService', function (FolderService) {
          if (file.folder) {
            return FolderService.get(file.folder);
          }
          var defer = $q.defer();
          defer.resolve(null);
          return defer.promise;
        }]
      },
      data: {
        entity: file,
        action: 'edit'
      }
    });
  };

  $scope.onDeleteFile = function(file) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/delete.html',
      controller: 'DeleteDialog',
      data: {
        object: file,
        type: 'file'
      }
    }).then(function(){
      $scope.loadPage($scope.page);
    });
  };

  $scope.onMoveFile = function(file) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/folder/selector.html',
      controller: 'FolderSelectorDialog',
      data: {
        excludeFolder: file.parent,
        rootDisabled: true,
        sector: $scope.getSector()
      }
    }).then(function(data) {
      var destiny = data ? data.destiny.id : data;
      if (data.action === 'move') {
        file.patch({folder: destiny}).then(function() {
          $scope.loadPage($scope.page);
        });
      }
      else {
        file.copyTo({to_folder: destiny}).then(function() {
          $scope.loadPage($scope.page);
        });
      }
    });
  };

  $scope.showSharePopup = function(file){
    ngDialog.open({
      template: 'views/templates/dialog/folder-file/share-file.html',
      controller: 'FolderFileShareDialog',
      data: {
        file: file
      }
    });
  };

  $scope.isExpired = function(file) {
    if (!file.archive && file.show_warning) {
      var today = moment(new Date());
      if (file.expiration && (moment(new Date(file.expiration)).format('YYYY-MM-DD') <= today.format('YYYY-MM-DD'))){
        return true;
      }
    }
    return false;
  };

  $scope.isNoticed = function(file) {
    if (!file.archive && file.show_warning) {
      var today = moment(new Date());
      if (file.notice && (moment(new Date(file.notice)).format('YYYY-MM-DD') <= today.format('YYYY-MM-DD'))){
        return true;
      }
    }
    return false;
  };

  $scope.showFileAddDialog = function(requirement) {
    ngDialog.open({
      template: 'views/templates/dialog/folder-file/upload.html',
      controller: 'FolderFileAdd',
      resolve: {
        folder: [function () {
          if (requirement.document_folder) {
            return requirement.document_folder;
          }
          return null;
        }]
      },
      data: {
        entity: null,
        action: 'create',
        status: 'missing',
        requirement: requirement
      }
    });
  };

  $scope.$on('folder-file:created', function() {
    $scope.loadPage($scope.page);
  });
  $scope.$on('folder-file:updated', function() {
    $scope.loadPage($scope.page);
  });

  $controller('TableFilterController', { $scope: $scope });
  $scope.loadPage(1);
};

app.controller('DocumentListReport', ['$scope', '$window', '$filter', 'FolderFileService', 'ngDialog', 'FilterService',
  'AuthDataService', 'NotificationService', '$timeout', '$controller', '$q', 'AttachmentService', 'AnalyticsService', DocumentListReport]);
